import React from 'react'
import cn from 'classnames'
import ButtonGroup from 'react-bootstrap/esm/ButtonGroup'
import ToggleButton from 'react-bootstrap/esm/ToggleButton'
import s from './CheckboxGroup.module.scss'

interface Props {
  id: string
  onChange: (value: number) => void
  options: { label: string; value: number }[]
  value: number | number[] | null
  disabled?: boolean
}

const defaultProps = {
  disabled: false,
}

/**
 *
 * @param value Use an array for multiple choices checkboxes
 */
const CheckboxGroup = ({
  id,
  onChange,
  value,
  options,
  disabled,
}: Props): JSX.Element => {
  const isChecked = (currentValue: number) => {
    if (Array.isArray(value)) return value.includes(currentValue)
    return value === currentValue
  }

  return (
    <ButtonGroup className={cn('checkbox-group', s.buttonGroupCheckbox)}>
      {options.map((option: { label: string; value: number }, idx: number) => (
        <ToggleButton
          id={`${id}-${option.label}-${option.value}`}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange(parseInt((e.target as HTMLInputElement).value, 10))
          }
          className={cn(s.toggleCheckbox, { [s.disabled]: disabled })}
          key={`${option.label}${idx}`}
          type="checkbox"
          variant="none"
          checked={isChecked(option.value)}
          value={option.value}
          disabled={disabled}
        >
          <span
            className={cn(s.checkmark, { [s.show]: isChecked(option.value) })}
          />
          <p className={s.label}>{option.label}</p>
        </ToggleButton>
      ))}
    </ButtonGroup>
  )
}

CheckboxGroup.defaultProps = defaultProps
export default CheckboxGroup
